import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const PasswordReset = lazy(
  () =>
    import('./PasswordReset.eager').then(mod => ({
      default: mod.PasswordReset,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
